import React from "react";
import "./index.scss";
import { useSelector } from "react-redux";
import { getPercentileInfo } from "../../util/cutscores";

export default function PercentileBox(props) {
  const { mastery, boxStyle, textStyle, percentile } = props;
  const { value } = mastery;

  const selectedStatePercentileCuts = useSelector(state => state.reports.teacher.selectedStatePercentileCuts);
  const percentileInfo = getPercentileInfo(percentile ?? value, selectedStatePercentileCuts);

  return (
    <div
      className="percentile-box"
      style={{
        ...boxStyle,
        minHeight: boxStyle.width,
        minWidth: boxStyle.width,
        height: boxStyle.width,
        background: percentileInfo.color,
      }}
      onClick={props.onClick}
    >
      <div style={textStyle}>{value}</div>
    </div>
  );
}
